const TICKET_PATH = /^\/issue\/([^/?#]+)\/?$/i;
const TASK_PATH = /^\/task\/([^/?#]+)\/?$/i;

const getInternalPathMatch = (href: string, pattern: RegExp): string | null => {
    if (!href || typeof window === 'undefined') return null;

    try {
        const url = new URL(href, window.location.origin);
        const allowedOrigins = new Set([window.location.origin]);
        const configuredAppUrl = process.env.REACT_APP_CURRENT_URL;
        if (configuredAppUrl) allowedOrigins.add(new URL(configuredAppUrl).origin);
        if (!allowedOrigins.has(url.origin)) return null;
        const match = url.pathname.match(pattern);
        return match ? decodeURIComponent(match[1]) : null;
    } catch {
        return null;
    }
};

/** Returns a public ticket id only for links that point back into this app. */
export const getTicketPublicIdFromHref = (href: string): string | null => {
    return getInternalPathMatch(href, TICKET_PATH);
};

export const getTaskReferenceFromHref = (href: string): string | null =>
    getInternalPathMatch(href, TASK_PATH);

export const getTicketHref = (publicId: string): string =>
    `/issue/${encodeURIComponent(publicId)}`;
